<template>
    <div id="app">
        <router-view v-if="isRouterAlive"/>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isRouterAlive: true
            }
        },
        provide() {
            return {
                reload: this.reload
            }
        },
        methods: {
            //刷新当前页面
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(() => {
                    this.isRouterAlive = true;
                })
            }
        }
    }
</script>

<style lang="scss">
/* body{
    font-family:"楷体" !important;
    font-weight: 900;
    background-color: #F0F0F0 ;
} */
.root {
    // margin: 50px 25px 0px 25px
  }

  .my-flex {
    // display: flex;
  }
</style>
